<template>
  <div :class="activeColor">
    <nav class="navbar navbar-expand-lg navbar-custom navbar-fixed-top">
      <a class="navbar-brand" href="#">
        <router-link to="/">
          <img src="@/assets/NearCode.png" width="60" height="60" alt="" />
        </router-link>
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav nav-fill w-100">
          <li class="nav-item active">
            <a class="nav-link" href="#"
              ><router-link to="/services">{{ this.contents.find(content => content.id_content === 166)?.title }}</router-link></a
            >
          </li>
          <img
            id="ball"
            src="@/assets/circle-01.svg"
            width="25"
            height="25"
            alt=""
          />
          <li class="nav-item">
            <a class="nav-link" href="#"
              ><router-link to="/about">{{ this.contents.find(content => content.id_content === 167)?.title }}</router-link></a
            >
          </li>
          <img
            id="ball"
            src="@/assets/circle-01.svg"
            width="25"
            height="25"
            alt=""
          />
          <li class="nav-item">
            <a class="nav-link" href="#">
              <router-link to="/carrers"> {{ this.contents.find(content => content.id_content === 168)?.title }}</router-link></a
            >
          </li>
          <img
            id="ball"
            src="@/assets/circle-01.svg"
            width="25"
            height="25"
            alt=""
          />
          <li class="nav-item">
            <a class="nav-link" href="#"
              ><router-link to="/contacts">{{ this.contents.find(content => content.id_content === 169)?.title }}</router-link></a
            >
          </li>
        </ul>

        <div class="language-switcher">
          <select v-model="language" @change="changeLanguage" class="lang-select">
            <option value="pt">🇵🇹 Português</option>
            <option value="en">🇬🇧 English</option>
          </select>
        </div>

      </div>
    </nav>
    <hr />
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Navbar",
  props: {},
  data: function() {
    return {
      contents: [],
      language: "pt"
    };
  },
  mounted() {
    this.getAllContent();

    const savedLang = localStorage.getItem("lang");
    if (savedLang) {
      this.language = savedLang;
    }

  },
  methods : {
    async getAllContent() {
      this.contents = [];
      try {
        await this.$store.dispatch("fetchContent");
        let lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : this.language;
        for (let i = 0; i < this.getContent.data.length; i++) {
          if (this.getContent.data[i].page == 7) {
            let content = {
              id_content: this.getContent.data[i].id_content,
              title: lang === "pt" ? this.getContent.data[i].title : this.getContent.data[i].title_en,
              description: lang ==="pt" ? this.getContent.data[i].description : this.getContent.data[i].description_en,
              img: this.img,
            };
            this.contents.push(content);
          }
        }
      } catch (err) {
        this.$router.push({ name: "Error" });
      }
    },
    changeLanguage() {
      localStorage.setItem("lang", this.language);
      this.$emit("change-language", this.language);
      window.location.reload();
    }
  },
  computed: {
    ...mapGetters(["getContent"]),
    activeColor() {
      return { dark: !!this.$route.meta?.mode };
    },
  },
};
</script>

<style>
hr {
  border: 0px;
}
nav {
  z-index: 2;
}

.navbar {
  margin-left: 100px;
  margin-right: 100px;
}

nav .navbar-nav li a {
  color: rgb(87, 87, 87);
  font-family: "Barlow", sans-serif;
  font-weight: 500;
  font-size: 30px;
}

.navbar-nav {
  display: flex;
  align-items: center;
}

nav .navbar-nav li a:hover,
nav .navbar-nav li a:focus {
  color: #f7941e;
  text-decoration: none;
}

.dark {
  background-color: #888888;
}

.dark nav .navbar-nav li a {
  color: white;
  font-family: "Barlow Regular", sans-serif;
  /* font-family: "Saira Extra Condensed", sans-serif; */
  font-size: 30px;
}

.dark nav .navbar-nav li a:hover,
.dark nav .navbar-nav li a:focus {
  color: orange;
  text-decoration: none;
}

.dark hr {
  border: 4px solid;
  color: #f7941e;
}

.language-switcher {
  margin-left: auto;
}

.lang-select {
  background: white;
  border: 1px solid #f7941e;
  padding: 5px 12px;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 8px;
}

.lang-select:hover {
  background: #f7941e;
  color: white;
}
</style>
